<div class="orbi-live-region" role="status" aria-live="polite" aria-atomic="true">{{ polite$ | async }}</div>

<div class="orbi-live-region" role="alert" aria-live="assertive" aria-atomic="true">{{ assertive$ | async }}</div>
